import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { Box, type BoxProps } from "@mui/material";

type DraggableImageProps = {
  dndId: string | number;
  data?: Record<string, unknown>;
  src?: string;
  alt?: string;
  disabled?: boolean;
  sx?: BoxProps["sx"];
};

function DraggableImage({
  dndId,
  data = {},
  src,
  alt = "",
  disabled = false,
  sx = {},
}: DraggableImageProps) {
  const { attributes, listeners, setNodeRef, isDragging, transform } =
    useDraggable({
      id: dndId,
      data,
      disabled,
    });
  return (
    <Box
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      component="img"
      src={src}
      alt={alt}
      loading="lazy"
      sx={{
        filter: disabled ? "opacity(0.4)" : "none",
        cursor: disabled ? "not-allowed!important" : "grab!important",
        transform: transform
          ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
          : undefined,
        zIndex: isDragging ? 10000 : 1,
        width: "100px",
        height: "100px",
        display: "block",
        objectFit: "contain",
        backgroundColor: "var(--neutral-white)",
        borderRadius: "var(--radius-control)",
        border: "1px solid var(--neutral-200)",
        ":hover": {
          boxShadow: "none",
        },
        ...sx,
      }}
    />
  );
}

export default DraggableImage;
